import React from 'react'

const NoDataFound = ({text}) => {
    return (
        <>
            <div className='text-center mt-5'>
                <h5>{text}</h5>
            </div>
        </>
    )
}

export default NoDataFound;